import React, { useState, useEffect } from 'react';

const TimeCountdown = ({ endTime }) => {

    console.log(endTime)
    const calculateTimeLeft = () => {
        
        const currentDate = new Date();
        const endDateTime = new Date(endTime);

        endDateTime.setFullYear(currentDate.getFullYear());
        endDateTime.setMonth(currentDate.getMonth());
        endDateTime.setDate(currentDate.getDate());

        const difference = endDateTime - currentDate;

        if (difference <= 0) {
            return {
                hours: '00',
                minutes: '00',
                seconds: '00'
            };
        }
        // Calculate hours, minutes, and seconds left
        let hoursLeft = Math.floor(difference / (1000 * 60 * 60));
        let minutesLeft = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        let secondsLeft = Math.floor((difference % (1000 * 60)) / 1000);


        //let hoursLeft = endDateTime.getHours() - currentDate.getHours();
        //let minutesLeft = endDateTime.getMinutes() - currentDate.getMinutes();
        //let secondsLeft = endDateTime.getSeconds() - currentDate.getSeconds();

        //if (secondsLeft < 0) {
        //    secondsLeft += 60;
        //    minutesLeft--;
        //}
        //if (minutesLeft < 0) {
        //    minutesLeft += 60;
        //    hoursLeft--;
        //}
        //if (hoursLeft < 0) {
        //    hoursLeft += 24;
        //}

        const formattedHours = String(hoursLeft).padStart(2, '0');
        const formattedMinutes = String(minutesLeft).padStart(2, '0');
        const formattedSeconds = String(secondsLeft).padStart(2, '0');

        console.log({
            hours: formattedHours,
            minutes: formattedMinutes,
            seconds: formattedSeconds
        })
        return {
            hours: formattedHours,
            minutes: formattedMinutes,
            seconds: formattedSeconds
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());

            //if (timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
            //    clearInterval(timer);
            //}

        }, 1000);

        return () => clearInterval(timer);
    }, [endTime]);

    return (
        <div>
          Auction ends in  <strong>{timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}</strong>
        </div>
    );
}

export default TimeCountdown;
